import { FormActionsMui } from '@app/components/form/actions/FormActionsMui';
import { composeRouteGenerator } from '@app/modules/compose/routing/compose-route-generator';
import { zodResolver } from '@hookform/resolvers/zod';
import { webApi } from '@mi-front/api-clients';
import { Stack } from '@mui/material';
import { FormContainer, TextFieldElement } from 'react-hook-form-mui';
import { defineMessage, useIntl } from 'react-intl';
import {
  composeCreateFormSchema,
  ComposeCreateFormValues,
} from '../create/compose-create-form.schema';
import { useComposeEditComposition } from './useComposeEditComposition';
import { Station } from '@app/core/types/stations';

const composeCreatePageFieldNameMessage = defineMessage({
  id: 'compose.createPage.fieldName',
  defaultMessage: 'Nombre',
});

interface ComposeEditFormProps {
  composition: webApi.EnrichedCompositionDetailDto;
  station: Station | undefined;
}

/**
 * Form to update a composition name (station is read-only context from the loaded composition).
 */
export function ComposeEditForm({ composition, station }: ComposeEditFormProps) {
  const { $t } = useIntl();
  const { submitEdit } = useComposeEditComposition({
    compositionId: composition.id,
    station,
  });

  const cancelPath = composeRouteGenerator.edits(composition.id);

  return (
    <FormContainer<ComposeCreateFormValues>
      defaultValues={{ name: composition.name }}
      resolver={zodResolver(composeCreateFormSchema)}
      onSuccess={async (values) => {
        await submitEdit(values.name);
      }}
    >
      <Stack spacing={3} useFlexGap sx={{ maxWidth: 480 }}>
        <TextFieldElement
          name="name"
          label={$t(composeCreatePageFieldNameMessage)}
          fullWidth
          required
          autoFocus
        />
        <FormActionsMui cancel={cancelPath} disableOnSubmit disableSubmitIfInvalid />
      </Stack>
    </FormContainer>
  );
}
